import { render, staticRenderFns } from "./QualityInspectionConfirmed.vue?vue&type=template&id=124e3c3c&scoped=true&"
import script from "./QualityInspectionConfirmed.vue?vue&type=script&lang=js&"
export * from "./QualityInspectionConfirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e3c3c",
  null
  
)

export default component.exports